import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { mobilePromo1, mobilePromo2, mobilePromo3, promotions } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobilePromo1} w="100%" alt="holiday" />
          <CFImage src={mobilePromo2} w="100%" alt="holiday" />
          <CFImage src={mobilePromo3} w="100%" alt="holiday" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center m="0 auto" maxWidth="1400px">
          {/* <CFImage src={holiday} w="80%" alt="holiday" mv="20px" /> */}
          <CFImage src={promotions} w="100%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
